export default {
	sec_01: {
		title: {
			one: '시작하기',
			two: 'JP WORLD ',
			three: 'Pay',
		},
		desc: {
			one: '모든 것은 비즈니스 계정에서 시작됩니다.',
			two: 'JP WORLD PAY에 의존하는 3천만명 이상의 판매자와 함께 하십시오.',
		},
		btn: {
			one: '회원가입하기',
			two: '영업팀에 문의',
		},
	},
	sec_14: {
		btn: '시작하려면 계정 전문가에게 문의하세요.',
	},
	sec_04: {
		title: {
			one: '쉬운 설정',
		},
		desc: {
			one: '문의하기. 도와드립니다.',
		},
		cards: {
			one: {
				title: {
					one: '가입은 무료입니다.',
				},
				description: {
					one: '이메일 주소와 비즈니스에 대한',
					two: '몇 가지 기본 정보만 있으면 됩니다.',
				},
				btn: '비즈니스 계정에 가입',
			},
			two: {
				title: {
					one: '지급 시작',
				},
				description: {
					one: '이메일 주소와 회사 이름을 확인하고',
					two: 'JP WORLD PAY 계좌를 연결하면',
					three: '첫 번째 판매준비가',
					four: '완료됩니다.',
				},
			},
		},
		btn: 'JP WORLD Pay',
	},
};
